import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomeScreen from './welcomescreen';
import Form1Screen from './Form1Screen';
import Form2Screen from './Form2Screen';
import Form3Screen from './Form3Screen';
import QualityReviewForm from './QualityReviewForm';
import WasteTransferForm from './WasteTransferForm';
import FettlerForm from './fettler';
import EECForm from './eec';
import HWMoonToyotaChecklist from './hwmoon';
import VWCorkillChecklist from './vwcorkill';
import SurgeryAuditForm from './surgery';
import KensiteChecklist from './kensite';

import PDFDashboard from './PDFDashboard';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WelcomeScreen />} />

        <Route path="/pdf-dashboard" element={<PDFDashboard />} />
        <Route path="/form1" element={<Form1Screen />} />
        <Route path="/form2" element={<Form2Screen />} />
        <Route path="/form3" element={<Form3Screen />} />
        <Route path="/quality-review" element={<QualityReviewForm />} />
        <Route path="/waste-transfer" element={<WasteTransferForm />} />
        <Route path="/fettler" element={<FettlerForm />} />
        <Route path="/eec" element={<EECForm />} />
        <Route path="/hwmoon" element={<HWMoonToyotaChecklist />} />
        <Route path="/vwcorkill" element={<VWCorkillChecklist />} />
        <Route path="/surgery" element={<SurgeryAuditForm />} />
        <Route path="/kensite" element={<KensiteChecklist />} />
      </Routes>
    </Router>
  );
}
